

















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import UserSummary from '@/dto/profile/UserSummary';
import UserSubscriptionDetailsDTO from '@/dto/subscription/UserSubscriptionDetailsDTO';
import { SubscriberType } from '@/constants/SubscriptionConstants';
import SubscriptionService from '@/services/SubscriptionService';
import { processError } from '@/utils/ComponentUtils';
import Clipboard from '@/state/Clipboard';

@Component({})
export default class AddProfilesAdminModal extends Vue {
  @Prop({ required: true }) readonly subscription!: UserSubscriptionDetailsDTO;
  @Prop({ required: true }) readonly userSummary!: UserSummary | null;

  selectedPersonSelected = false;
  selectedCompanyIds: number[] = [];
  sendLinkToCustomer = true;

  processing = false;
  approveLink: string | null = null;
  validationErrors: string[] = [];

  get availablePerson() {
    if (!this.userSummary || !this.userSummary.person) return null;
    if (this.subscription.subscriberType === SubscriberType.COMPANY) return null;
    if (this.subscription.person && this.subscription.person.id === this.userSummary.person.id) return null;
    return this.userSummary.person;
  }

  get availableCompanies() {
    if (!this.userSummary) return [];
    if (this.subscription.subscriberType === SubscriberType.PERSON) return [];
    const currentIds = new Set(this.subscription.companies.map(c => c.id));
    return this.userSummary.companies.filter(c => !currentIds.has(c.id));
  }

  selectAllCompanies() {
    this.selectedCompanyIds = this.availableCompanies.map(c => c.id);
  }

  clearCompanies() {
    this.selectedCompanyIds = [];
  }

  get isValid(): boolean {
    this.validationErrors = [];
    if (!this.selectedPersonSelected && this.selectedCompanyIds.length === 0) {
      this.validationErrors.push('Select at least one profile to add');
    }
    return this.validationErrors.length === 0;
  }

  async addProfiles() {
    if (!this.isValid) return;
    this.processing = true;
    try {
      const payload = {
        personId: this.selectedPersonSelected && this.availablePerson ? this.availablePerson.id : null,
        companyIds: this.selectedCompanyIds,
        sendLinkToCustomer: this.sendLinkToCustomer
      };
      const resp = await SubscriptionService.addProfilesToSubscriptionAdmin(this.subscription.agreementId, payload);
      this.approveLink = resp.data;
      this.$emit('added', this.approveLink);
    } catch (e) {
      processError(this, e);
    } finally {
      this.processing = false;
    }
  }

  copyApproveLink() {
    if (!this.approveLink) return;
    Clipboard.write(this.approveLink);
  }
}
